<div class="card-container"  [class.account-manager]="role === 'accountManager'">
  <!-- <nz-header class="site-page-header" nzTitle="Summary"></nz-header> -->
  <nz-tabset nzType="card">
    <nz-header class="site-page-header" nzTitle="Summary"></nz-header>
    <nz-tab  *ngIf="role !== 'accountManager'" [nzTitle]="titleTemplate1">
      <ng-template #titleTemplate1>
        <span nz-icon nzType="pie-chart" nzTheme="outline"></span>
        Billing Dashboard
      </ng-template>
      <nz-card style="margin-bottom: 16px;"> 

        <div nz-row [nzGutter]="16" class="filter-row" style="align-items: end; margin-bottom: 16px;">
          <!-- Date Range -->
          <div nz-col [nzSpan]="6" class="filter-item">
            <label for="dateRange" class="ant-form-item-label">Date Range</label>
            <nz-range-picker nzRangePicker style="width: 100%;" [(ngModel)]="date" (ngModelChange)="onChange()"></nz-range-picker>
          </div>
        
          <!-- Countries -->
          <div nz-col [nzSpan]="4" class="filter-item">
            <label for="countries" class="ant-form-item-label">Countries</label>
            <nz-select nzPlaceHolder="All Countries" style="width: 100%;">
              <nz-option nzLabel="All Countries" nzValue="all"></nz-option>
              <nz-option nzLabel="India" nzValue="india"></nz-option>
            </nz-select>
          </div>
        
          <!-- Carriers -->
          <!-- <div nz-col [nzSpan]="4" class="filter-item">
            <label for="carriers" class="ant-form-item-label">Carriers</label>
            <nz-select nzPlaceHolder="All Carriers" style="width: 100%;">
              <nz-option nzLabel="All Carriers" nzValue="all"></nz-option>
            </nz-select>
          </div> -->

           <!-- <div nz-col [nzSpan]="4" class="filter-item">
            <label for="brands" class="ant-form-item-label">Brands</label>
            <nz-select nzPlaceHolder="All Brands" style="width: 100%;">
              <nz-option nzLabel="All Brands" nzValue="all"></nz-option>
              <nz-option *ngFor="let data of brand" [nzLabel]="data.brandName" [nzValue]="data.brandName"></nz-option>
            </nz-select>
          </div> -->
        
          <!-- Bots -->
          <div nz-col [nzSpan]="4" class="filter-item">
            <label for="bots" class="ant-form-item-label">Bots</label>
            <nz-select nzPlaceHolder="All Bots" style="width: 100%;" [(ngModel)]="botSelected">
              <nz-option nzLabel="All Bots" nzValue=""></nz-option>
              <nz-option *ngFor="let data of bots" [nzLabel]="data.botName" [nzValue]="data.botName"></nz-option>
            </nz-select>
          </div>
        
          <!-- List By -->
          <div nz-col [nzSpan]="4" class="filter-item">
            <label for="listBy" class="ant-form-item-label">List By</label>
            <nz-select nzPlaceHolder="Brands" style="width: 100%;" [(ngModel)]="selectedOption" (ngModelChange)="onListByChange()">
              <nz-option nzLabel="Brands" nzValue="brand"></nz-option>
              <nz-option nzLabel="Bots" nzValue="bot"></nz-option>
              <nz-option nzLabel="Template" nzValue="template"></nz-option>
              <nz-option nzLabel="Campaign" nzValue="campaign"></nz-option>
            </nz-select>
          </div>
        
          <!-- Search Button -->
          <div nz-col [nzSpan]="2" class="filter-item" style="text-align: right;">
            <button nz-button nzType="primary" class="dashboard-search-btn" style="width: 100%;" (click)="onSearchClick()">Search</button>
          </div>
        </div>
        


        <!-- <div class="search-container">
          <button nz-button nzType="primary" (click)="onSearchClick()">Search</button>
        </div> -->
      </nz-card>

     <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
      <h2>Summary</h2>

      <div class="dashboard-btns">
        <button style="border-radius: 30px;" nz-button nzType="default" class="px-4 py-2" [ngClass]="{ 'active-btn': isGraphVisible }" (click)="showGraph()">
          Visual Insights
        </button>
      
        <button style="border-radius: 30px;" nz-button nzType="default" class="px-4 py-2"  [ngClass]="{ 'active-btn': isDashboardVisible }" (click)="showDashboard()">
          Key Metrics
        </button>
      
        <button style="border-radius: 30px;" nz-button nzType="default" class="px-4 py-2" [ngClass]="{ 'active-btn': isDashboardTableVisible }"
        (click)="showDashboardTable()">
          Data Table
        </button>
      </div>

    <button style="border-radius: 30px;" nz-button nzType="default" class="px-4 py-2" (click)="downloadCSV()">
          Download Summary
          <i nz-icon nzType="download"></i>
        </button>
    </div>

      

        <div *ngIf="isDashboardVisible" nz-row [nzGutter]="24" class="dashboard-stats">
          <div nz-col [nzSpan]="8">
            <nz-card nzHoverable nzTitle="Basic Message">
              <div class="stat-value">
                {{totalBasicMessages || "-"}}
                <i nz-icon nzType="message" style="color: #1890ff;"></i>
              </div>
            </nz-card>
          </div>

          <div nz-col [nzSpan]="8">
            <nz-card nzHoverable nzTitle="Rich SMS">
              <div class="stat-value">
                {{totalRichSms || "-"}}
                <i nz-icon nzType="notification" style="color: #eb2f96;"></i>
              </div>
            </nz-card>
          </div>
        
          <div nz-col [nzSpan]="8">
            <nz-card nzHoverable nzTitle="A2P Single Message">
              <div class="stat-value">
                {{ totalA2PSingleMessages || "-"}}
                <i nz-icon nzType="mail" style="color: #13c2c2;"></i>
              </div>
            </nz-card>
          </div>
        
          <div nz-col [nzSpan]="8">
            <nz-card nzHoverable nzTitle="A2P Conversation">
              <div class="stat-value">
                {{ totalA2PConversation || "-"}}
                <i nz-icon nzType="comment" style="color: #faad14;"></i>
              </div>
            </nz-card>
          </div>
        
          <div nz-col [nzSpan]="8">
            <nz-card nzHoverable nzTitle="P2A Conversation">
              <div class="stat-value">
                {{ totalP2AConversation || "-"}}
                <i nz-icon nzType="message"></i>
              </div>
            </nz-card>
          </div>
        
          <div nz-col [nzSpan]="8">
            <nz-card nzHoverable nzTitle="Rich OTP">
              <div class="stat-value">
                {{totalRichOTP || "-"}}
                <i nz-icon nzType="key" style="color: #722ed1;"></i>
              </div>
            </nz-card>
          </div>
        
        </div>
        

      <!-- Graph -->
      <div *ngIf="isGraphVisible" style="width: 100%; max-width: 800px; margin: auto;">
        <canvas id="summaryBarChart"></canvas>
      </div>
      
      
      <nz-table
  *ngIf="isDashboardTableVisible"
  #basicTable
  [nzBordered]="true"
  [nzSize]="'middle'"
  [nzData]="tableData"
  [nzPageSize]="5"
  [nzShowPagination]="true"
  [nzPageSize]="pageSize"
  [nzPageIndex]="pageIndex"
  [nzTotal]="totalRecords"
  [nzLoading]="loading"
>
  <thead>
    <tr>
      <th nzWidth="10%" *ngIf="selectedOption === 'bot'">Bot</th>
      <th nzWidth="10%" *ngIf="selectedOption === 'brand'">Brand Name</th>
      <th nzWidth="10%" *ngIf="selectedOption === 'template'">Template</th>
      <th nzWidth="10%" *ngIf="selectedOption === 'campaign'">Campaign</th>

      <!-- ✅ Username column added here -->
      <th *ngIf="role==='admin'|| role ==='reseller'" nzWidth="10%">Username</th>

      <th nzWidth="10%">Date</th>
      <th nzWidth="10%">Basic Message</th>
      <th nzWidth="12%">A2P Single Message</th>
      <th nzWidth="10%">A2P Conversation</th>
      <th nzWidth="10%">P2A Conversation</th>
      <th nzWidth="10%">Rich OTP</th>
      <th nzWidth="10%">Rich SMS</th>
      <th nzWidth="10%">Awaited</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let dt of basicTable.data">
      <td *ngIf="selectedOption === 'bot'">{{ dt.botName }}</td>
      <td *ngIf="selectedOption === 'brand'">{{ dt.brandName }}</td>
      <td *ngIf="selectedOption === 'template'">{{ dt.templateName }}</td>
      <td *ngIf="selectedOption === 'campaign'">{{ dt.campaignName }}</td>

      <!-- ✅ Username cell -->
      <td *ngIf="role==='admin'|| role ==='reseller'">{{ dt.userName || '-' }}</td>

      <td>{{ dt.summaryDate | date: 'dd-MM-yyyy' }}</td>
      <td>{{ dt.totalBasicMessages || 0 }}</td>
      <td>{{ dt.totalA2PSingleMessages || 0 }}</td>
      <td>{{ dt.totalA2PConversation || 0 }}</td>
      <td>{{ dt.totalP2AConversation || 0 }}</td>
      <td>{{ dt.totalRichOTP || 0 }}</td>
      <td>{{ dt.totalRichSMS || 0 }}</td>

      <td>
        {{
          ((dt.totalSubmitted || 0) -
            ((dt.operatorTotalSubmitted || 0) + (dt.totalFailed || 0)) >
          0
            ? (dt.totalSubmitted || 0) -
              ((dt.operatorTotalSubmitted || 0) + (dt.totalFailed || 0))
            : 0)
        }}
      </td>
    </tr>
  </tbody>
</nz-table>

    </nz-tab>



    <nz-tab [nzTitle]="titleTemplate2">
      <ng-template #titleTemplate2>
        <span nz-icon nzType="pie-chart" nzTheme="outline"></span>
        Traffic Dashboard
      </ng-template>
      <nz-card style="margin-bottom: 16px;">
        
        <div nz-row [nzGutter]="4" class="filter-row">
          <!-- Date Range -->
          <div nz-col [nzSpan]="6" class="filter-item">
            <label for="dateRange" class="ant-form-item-label">Date Range </label>
            <nz-range-picker nzRangePicker style="width: 100%;" [(ngModel)]="date" (ngModelChange)="onChange()"
              nzPlaceHolder=""></nz-range-picker>
          </div>

          <!-- Countries -->
          <div nz-col [nzSpan]="4" class="filter-item">
            <label for="countries" class="ant-form-item-label">Countries</label>
            <nz-select nzPlaceHolder="All Countries" style="width: 100%;">
              <nz-option nzLabel="All Countries" nzValue="all"></nz-option>
              <nz-option nzLabel="India" nzValue="india"></nz-option>
            </nz-select>
          </div>

          <!-- Carriers -->
          <!-- <div nz-col [nzSpan]="4" class="filter-item">
            <label for="carriers" class="ant-form-item-label">Carriers</label>
            <nz-select nzPlaceHolder="All Carriers" style="width: 100%;">
              <nz-option nzLabel="All Carriers" nzValue="all"></nz-option>
            </nz-select>
          </div> -->

          <!-- Brands -->
          <div nz-col [nzSpan]="4" class="filter-item">
            <label for="bots" class="ant-form-item-label">Bots</label>
            <nz-select nzPlaceHolder="All Bots" style="width: 100%;" [(ngModel)]="botSelected">
              <nz-option nzLabel="All Bots" nzValue=""></nz-option>
              <nz-option *ngFor="let data of bots" [nzLabel]="data.botName" [nzValue]="data.botName"></nz-option>
            </nz-select>
          </div>
            <!-- <div nz-col [nzSpan]="4" class="filter-item">
              <app-brand-dropdown (dataEvent)="receiveDataBrand($event)"></app-brand-dropdown>
            </div> -->
            <div nz-col [nzSpan]="4" class="filter-item">
              <app-template-dropdown (templateEvent)="receiveDataTemplate($event)" ></app-template-dropdown>
            </div>
            
            
          <!-- Campaigns -->
          <div nz-col [nzSpan]="4" class="filter-item">
            <label class="ant-form-item-label">Campaigns</label>
            <nz-select [(ngModel)]="selectedCampaign" nzPlaceHolder="All Campaigns" style="width: 100%;">
              <nz-option nzLabel="All Campaigns" nzValue=""></nz-option>
              <nz-option *ngFor="let data of campList" [nzLabel]="data.campaignName" [nzValue]="data.campaignName" />
            </nz-select>
          </div>

          <!-- Time Range -->
          <!-- <div nz-col [nzSpan]="4" class="filter-item">
            <label class="ant-form-item-label">
              Time Range
            </label>
            <div class="time-picker-container">
              <nz-time-picker nzRangePicker [(ngModel)]="startTime" [nzFormat]="'HH:mm'"></nz-time-picker>
              <span class="separator">to</span>
              <nz-time-picker [(ngModel)]="endTime" [nzFormat]="'HH:mm'"></nz-time-picker>
            </div>
          </div> -->
          <!-- List By -->
          <div nz-col [nzSpan]="4" class="filter-item">
            <label for="listBy" class="ant-form-item-label" >List By</label>
            <nz-select nzPlaceHolder="Brands" style="width: 100%;" [(ngModel)]="selectedOption" (ngModelChange)="onListByChange()">
              <nz-option nzLabel="Brands" nzValue="brand"></nz-option>
              <nz-option nzLabel="Bots" nzValue="bot"></nz-option>
              <nz-option nzLabel="Template" nzValue="template"></nz-option>
              <nz-option nzLabel="Campaigns" nzValue="campaign"></nz-option>
            </nz-select>
          </div>
        

        <!-- Search Button -->
       <div nz-col [nzSpan]="4" style="display: flex; align-items: flex-end;">
        <button nz-button nzType="primary" class="dashboard-search-btn" (click)="onSearchClick()" style="margin-right: 8px;">Search</button>
        <button nz-button nzType="primary" class="dashboard-search-btn" (click)="Downloadtraffic()">Download</button>
      </div>

      </div>
      </nz-card>

      <nz-table
      #tableData2
      [nzData]="tableData"
      [nzBordered]="true"
      [nzSize]="'middle'"
      [nzScroll]="{ x: '2400px' }"
      [nzPageSize]="5"
      [nzShowPagination]="true"
      [nzPageSize]="pageSize"
      [nzPageIndex]="pageIndex"
      [nzTotal]="totalRecords"
      [nzLoading]="loading"
    >
      <thead>
        <tr>
          <th nzAlign="center" nzWidth="50%" *ngIf="selectedOption === 'bot'">Bot</th>
          <th nzAlign="center" nzWidth="50%" *ngIf="selectedOption === 'brand'">Brand Name</th>
          <th nzAlign="center" nzWidth="50%" *ngIf="selectedOption === 'template'">Template Name</th>
          <th nzAlign="center" nzWidth="50%" *ngIf="selectedOption === 'campaign'">Campaigns Name</th>
    
          <th *ngIf="role==='admin'|| role ==='reseller'" nzAlign="center" nzWidth="50%" [nzSortFn]="sortFnUserName">
            <span style="gap:8px;">User&nbsp;Name
              <i nz-icon style="color: #ff0909;" nzType="info-circle" nz-tooltip
                nzTooltipTitle="The user name from response."></i>
            </span>
          </th>
    
          <th nzAlign="center" nzWidth="50%" [nzSortFn]="sortFnDateTime">
            <span style="gap:8px;">Summary&nbsp;Date
              <i nz-icon style="color: #ff0909;" nzType="info-circle" nz-tooltip
                nzTooltipTitle="The summary date from response."></i>
            </span>
          </th>
    
          <th nzAlign="center" nzWidth="50%" [nzSortFn]="sortFnMessagesSubmitted">
            <span style="gap:8px;">Total&nbsp;Request
              <i nz-icon style="color: #ff0909;" nzType="info-circle" nz-tooltip
                nzTooltipTitle="The total number of requests."></i>
            </span>
          </th>
    
          <th nzAlign="center" nzWidth="50%" [nzSortFn]="sortFnP2operator">
            <span style="gap:8px;">Message&nbsp;Submitted
              <i nz-icon style="color: #ff0909;" nzType="info-circle" nz-tooltip
                nzTooltipTitle="The total number of messages submitted."></i>
            </span>
          </th>
    
          <th nzAlign="center" nzWidth="50%" [nzSortFn]="sortFnMessagesDelivered">
            <span style="gap:8px;">Messages&nbsp;Delivered
              <i nz-icon style="color: #ff0909;" nzType="info-circle" nz-tooltip
                nzTooltipTitle="Messages for which a delivery report was received."></i>
            </span>
          </th>
    
          <th nzAlign="center" nzWidth="50%" [nzSortFn]="sortFnMessagesRead">
            <span style="gap:8px;">Messages&nbsp;Read
              <i nz-icon style="color: #ff0909;" nzType="info-circle" nz-tooltip
                nzTooltipTitle="Total number of messages that were read."></i>
            </span>
          </th>
    
          <th nzAlign="center" nzWidth="50%" [nzSortFn]="sortFnMessagesFailed">
            <span style="gap:8px;">Failed/RCS&nbsp;Disabled Number
              <i nz-icon style="color: #ff0909;" nzType="info-circle" nz-tooltip
                nzTooltipTitle="Messages that failed to send."></i>
            </span>
          </th>
    
          <th nzAlign="center" nzWidth="50%" [nzSortFn]="sortFnRevokedExpired">
            <span style="gap:8px;">Revoked/Expired
              <i nz-icon style="color: #ff0909;" nzType="info-circle" nz-tooltip
                nzTooltipTitle="Messages that were revoked or expired."></i>
            </span>
          </th>
    
          <th nzAlign="center" nzWidth="37%" [nzSortFn]="sortFnP2Awaited">
            <span style="gap:8px;">Messages&nbsp;Awaited
              <i nz-icon style="color: #ff0909;" nzType="info-circle" nz-tooltip
                nzTooltipTitle="Messages still awaited."></i>
            </span>
          </th>
        </tr>
    
        <tr>
          <th nzAlign="center">Total Count</th>
          <th nzAlign="center"></th>
          <th *ngIf="role==='admin'" nzAlign="center"></th>
          <th nzAlign="center">{{ totalRequest }}</th>
          <th nzAlign="center">{{ totalSubmitted }}</th>
          <th nzAlign="center">{{ totalDelivered }}</th>
          <th nzAlign="center">{{ totalRead }}</th>
          <th nzAlign="center">{{ totalFailed }}</th>
          <th nzAlign="center">{{ totalExpired }}</th>
          <th nzAlign="center">{{ getDLRAwaited() }}</th>
        </tr>
      </thead>
    
      <tbody>
        <ng-container>
          <tr *ngFor="let item of tableData2.data">
            <td nzAlign="center" *ngIf="selectedOption == 'bot'">{{ item.botName }}</td>
            <td nzAlign="center" *ngIf="selectedOption == 'brand'">{{ item.brandName }}</td>
            <td nzAlign="center" *ngIf="selectedOption == 'template'">{{ item.templateName }}</td>
            <td nzAlign="center" *ngIf="selectedOption == 'campaign'">{{ item.campaignName }}</td>
    
            <td *ngIf="role==='admin'|| role ==='reseller'" nzAlign="center">{{ item.userName || '-' }}</td>
            <td nzAlign="center">{{ item.summaryDate || '0' }}</td>
            <td nzAlign="center">{{ item.totalRequest || '0' }}</td>
            <td nzAlign="center">{{ item.totalSubmitted || '0' }}</td>
            <td nzAlign="center">{{ item.totalDelivered || '0' }}</td>
            <td nzAlign="center">{{ item.totalRead || '0' }}</td>
            <td nzAlign="center">{{ item.totalFailed || '0' }}</td>
            <td nzAlign="center">{{ item.totalExpired || '0' }}</td>
            <td nzAlign="center">
              {{
                ((item.totalSubmitted || 0) - ((item.totalDelivered || 0) + (item.totalFailed || 0)) > 0)
                  ? ((item.totalSubmitted || 0) - ((item.totalDelivered || 0) + (item.totalFailed || 0)))
                  : 0
              }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
    

      <ng-template #emptyState>
        <tr>
          <td colspan="7" style="text-align: center; padding: 20px;">
            <div class="empty-state">
              <i nz-icon nzType="frown" nzTheme="outline" style="font-size: 24px; color: #999;"></i>
              <p style="margin-top: 8px; color: #666;">No records found</p>
            </div>
          </td>
        </tr>
      </ng-template>




    </nz-tab>
  </nz-tabset>

</div>